var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"el-icon-caret-top",staticStyle:{"color":"#1e88e5"}})
}
var staticRenderFns = []

export { render, staticRenderFns }